<template>
  <div class="custom-select" dir="rtl">
    <div class="custom-select__label">{{ label }}</div>
    <Treeselect
      name="מגזר"
      :multiple="multiple"
      :disable-branch-nodes="disableBranchNodes"
      :clearable="true"
      :searchable="true"
      :open-on-click="true"
      :open-on-focus="true"
      :openDirection="openDirection"
      :placeholder="placeholder"
      :noChildrenText="noChildrenText"
      :valueFormat="valueFormat"
      :options="options"
      :limit="0"
      :limitText="count => ` (${count}) נבחרו`"
      :max-height="150"
      v-model="internalValue"
      :value-consists-of="priority"
      :load-options="loadOptions"
      :disabled="disabled"
      :class="{ error: errorInput }"
      ><slot></slot
    ></Treeselect>
  </div>
  <!-- @select="select" -->

  <!-- :value-consists-of="'LEAF_PRIORITY'" -->
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect
  },
  props: {
    errorInput: {
      type: Boolean,
      default: false
    },
    disableBranchNodes: {
      type: Boolean,
      default: true
    },
    valueFormat: {
      type: String,
      default: 'id'
    },
    disable_branch: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    openDirection: {
      type: String,
      default: 'bottom'
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    options: {
      type: Array,
      require: true
    },
    value: {
      type: [Array, String, Number, Object]
    },
    priority: {
      type: String,
      default: 'BRANCH_PRIORITY'
    },
    noChildrenText: {
      type: String,
      default: 'אין פריטים'
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    loadOptions({ action, parentNode, callback }) {
      this.$emit('loadOptions', action, parentNode, callback);
    }
  }
};
</script>

<style lang="scss">
.error {
  .vue-treeselect__control {
    border-color: red !important;
  }
}
.vue-treeselect--open {
  .vue-treeselect__control {
    .vue-treeselect__control-arrow-container {
      transform: scaleY(-1);
    }
  }
}
.vue-treeselect__x-container {
  padding-left: 25px;
  padding-bottom: 3px;
}
.custom-select {
  position: relative;
  &__label {
    z-index: 1;
    position: absolute;
    top: 4px;
    right: 12px;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: #38455d;
    pointer-events: none;
    transition: 0.3s;
  }
  .vue-treeselect__single-value {
    padding-top: 12px;
  }
  .vue-treeselect {
    &__control {
      height: 48px;
      border: 1px solid #e3e7ee;
      border-radius: 8px;
      padding: 0 12px;
    }
    &__multi-value {
      margin-bottom: 0px !important;
      display: flex;
    }
    &__placeholder {
      height: auto;
      top: 20px;
      right: 0px;
      left: auto;
      bottom: auto;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: right;
      color: #8e9ebb;
      padding: 0;
    }
    &__limit-tip {
      padding: 0;
    }
    &__limit-tip-text {
      margin: 16px 0px 0 0;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: right;
      color: #38455d;
    }
    &__control-arrow-container {
      position: absolute;
      top: 30%;
      transform: scaleY(1);
      left: 12px;
      width: 16px;
      height: 16px;
      background-image: url(../../../../img/arrow-drop-down.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      svg {
        display: none;
      }
    }
    &__input-container {
      padding: 0 !important;
      margin-top: 16px;
    }
    &__input {
      padding: 0;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: right;
      color: #38455d;
    }
    &__menu {
      // top: 4px;
      padding: 4px 0;
      background: #ffffff;
      border: 1px solid #e3e7ee;
      box-shadow: 0px 4px 12px -2px rgba(56, 69, 93, 0.12),
        0px 2px 4px rgba(56, 69, 93, 0.04);
      border-radius: 8px;
      width: 100%;
    }
    &__list-item {
      &:not(:last-child) {
        .vue-treeselect__option {
          border-bottom: 1px solid #e3e7ee;
        }
      }
    }
    &__option {
      padding: 6px 12px !important;
      display: flex;
      align-items: center;
      position: relative;
      &.vue-treeselect__option--highlight {
        background: #eef7ff;
      }
    }
    &__option-arrow-container {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 12px;
      width: 16px;
      height: 16px;
      background-image: url(../../../../img/chevron-down-grey.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      svg {
        display: none;
      }
    }
    &__label-container {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &__checkbox-container {
      height: 20px;
    }
    &__checkbox {
      width: 20px;
      height: 20px;
      border: 1px solid #c7cfdd;
      border-radius: 4px;
    }
    &__label {
      padding: 0 !important;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: right;
      color: #38455d;
    }
    &__option-arrow-placeholder {
      display: none !important;
    }
    &__indent-level-0 {
      .vue-treeselect__list {
        .vue-treeselect__option {
          padding-right: 32px !important;
        }
      }
    }
    &__check-mark,
    &__minus-mark {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &__checkbox--checked {
      background-color: #409fff;
      border-color: #409fff;
    }
  }
}
</style>
